import { useIframeDialogStore } from '../model/iframe-dialog-store';
import { Modal } from './modal/modal';
import { FC, useEffect } from 'react';
import { WithChildren } from 'ts-types';

export const IframeDialogProvider: FC<WithChildren> = ({ children }) => {
  const { link, close } = useIframeDialogStore();

  useEffect(() => close, [close]);

  return (
    <>
      {children} {Boolean(link?.trim()) && <Modal />}
    </>
  );
};
